export interface SystemDefinition {
  key:         string;
  label:       string;
  description: string;
  icon:        string;
  route:       string;
  category:    'astrology' | 'divination' | 'esoteric' | 'personal';
  isPremium:   boolean;
}

export const SYSTEMS_CATALOG: SystemDefinition[] = [
  {
    key:         'mapa_natal',
    label:       'Mapa Natal',
    description: 'Seu mapa astral completo com planetas, casas e aspectos',
    icon:        '🌟',
    route:       '/mapa',
    category:    'astrology',
    isPremium:   false,
  },
  {
    key:         'previsao',
    label:       'Previsões',
    description: 'Previsões diárias, semanais e mensais personalizadas',
    icon:        '🔮',
    route:       '/previsoes',
    category:    'astrology',
    isPremium:   false,
  },
  {
    key:         'sinastria',
    label:       'Sinastria',
    description: 'Compatibilidade astrológica com quem você quiser',
    icon:        '💫',
    route:       '/sinastria/inicio',
    category:    'astrology',
    isPremium:   false,
  },
  {
    key:         'tarot',
    label:       'Tarot',
    description: 'Tiragem de cartas para orientação e reflexão',
    icon:        '🃏',
    route:       '/tarot',
    category:    'divination',
    isPremium:   false,
  },
  {
    key:         'numerologia',
    label:       'Numerologia',
    description: 'Análise numerológica do seu nome e data de nascimento',
    icon:        '🔢',
    route:       '/numerologia',
    category:    'esoteric',
    isPremium:   false,
  },
  {
    key:         'quiromancia',
    label:       'Quiromância',
    description: 'Leitura das linhas da mão por foto',
    icon:        '✋',
    route:       '/quiromancia',
    category:    'divination',
    isPremium:   true,
  },
  {
    key:         'i_ching',
    label:       'I Ching',
    description: 'Oráculo clássico chinês de 64 hexagramas',
    icon:        '☯️',
    route:       '/iching',
    category:    'divination',
    isPremium:   false,
  },
  {
    key:         'design_humano',
    label:       'Design Humano',
    description: 'Seu tipo, estratégia e autoridade no Design Humano',
    icon:        '⚡',
    route:       '/design-humano',
    category:    'esoteric',
    isPremium:   true,
  },
  {
    key:         'astrologia_vedica',
    label:       'Astrologia Védica',
    description: 'Mapa astral segundo a tradição indiana Jyotish',
    icon:        '🕉️',
    route:       '/vedico',
    category:    'astrology',
    isPremium:   true,
  },
  {
    key:         'astrocartografia',
    label:       'Astrocartografia',
    description: 'Descubra os melhores lugares do mundo para você',
    icon:        '🗺️',
    route:       '/astrocartografia',
    category:    'astrology',
    isPremium:   true,
  },
  {
    key:         'agenda_astrologica',
    label:       'Agenda Astral',
    description: 'Calendário personalizado com os melhores dias',
    icon:        '📅',
    route:       '/agenda',
    category:    'personal',
    isPremium:   true,
  },
  {
    key:         'fases_lua',
    label:       'Fases da Lua',
    description: 'Calendário lunar e influências para cada fase',
    icon:        '🌙',
    route:       '/fases-lua',
    category:    'astrology',
    isPremium:   false,
  },
  {
    key:         'retrogrados',
    label:       'Radar Retrógrado',
    description: 'Planetas retrógrados e como te afetam',
    icon:        '🌀',
    route:       '/retrogrado',
    category:    'astrology',
    isPremium:   false,
  },
  {
    key:         'eclipse',
    label:       'Eclipse Insight',
    description: 'Eclipses e seus efeitos no seu mapa pessoal',
    icon:        '🌑',
    route:       '/eclipses',
    category:    'astrology',
    isPremium:   true,
  },
  {
    key:         'diario_sonhos',
    label:       'Diário de Sonhos',
    description: 'Registre e interprete seus sonhos com astrologia',
    icon:        '💭',
    route:       '/diario-sonhos',
    category:    'personal',
    isPremium:   false,
  },
  {
    key:         'atlas_astral',
    label:       'Atlas Astral',
    description: 'Compatibilidade de cidades e países com seu mapa',
    icon:        '🌍',
    route:       '/atlas-astral',
    category:    'personal',
    isPremium:   true,
  },
];

export const CATEGORY_LABELS: Record<SystemDefinition['category'], string> = {
  astrology:  'Astrologia',
  divination: 'Adivinhação',
  esoteric:   'Esotérico',
  personal:   'Pessoal',
};
